import * as React from 'react'

import { Status, StoreStatus } from '../../StoreDetailsCard/StoreStatus'
import { StoreOpeningTime } from '../../StoreSearch/types'

import { StoreDetailsHeadingWrapper, Title } from './styles'

interface StoreDetailsHeadingProps {
  title?: string
  status: Status
  openingTimes: StoreOpeningTime
  isOpen: boolean
  hideStoreLocatorOpeningTimes?: boolean
  i18nText: {
    storeOpenText?: string
    storeClosedText?: string
    storeTempClosed?: string
    storePermClosed?: string
  }
}

export const StoreDetailsHeading = (props: StoreDetailsHeadingProps) => (
  <StoreDetailsHeadingWrapper>
    <Title>{props.title}</Title>
    {!props.hideStoreLocatorOpeningTimes && (
      <StoreStatus
        status={props.status}
        openingTimes={props.openingTimes}
        i18n={props.i18nText}
        isOpen={props.isOpen}
      />
    )}
  </StoreDetailsHeadingWrapper>
)
